export default __webpack_public_path__ + "static/icons-003a3e6e9847c779cf9131e056da464a.svg";